import React from 'react';

const LessonIndicator = ({ currentLessonNumber, totalLessons }) => (
  <div className="mb-2 text-blue-03 text-sm font-semibold">
    Lesson {currentLessonNumber + 1} of {totalLessons}
  </div>
);

export default LessonIndicator;
